/*===================================================================
=       GENERAL INFO VIEW                     =
====================================================================*/
import FilesList, {
  FileItem,
} from "../../../../../../components/molecules/FilesList/FilesList";
import TextBox from "../../../../../../components/molecules/TextBox/TextBox";
import styles from "./GeneralInfoView.module.scss";
import HistoricStatusPresenter from "../../HistoricStatus/HistoricStatusPresenter";
import { TeamInfo } from "../../../../../team/components/SingleTeam/TeamInfo";


export interface User {
  firstname?: string;
  lastname?: string;
}

export interface GeneralInfoViewProps {
  userName?: string;
  userLastname?: string;
  statut?: string;
  colorStatus?: {backgroundColor?: string; color?: string};
  paymentDate?: string;
  amount?: string;
  totalSpent?: string;
  remainingAmount?: string;
  totalCredit?: string;
  totalSubCredit?: string;
  totalPayedCollab?: string;
  totalAcompte?: string;
  totalCreditAvailable?: string;
  subCreditBalance?: string;
  isTotalSpentExceeded?: boolean;
  isRemainingAmountPositive?: boolean;
  isSubCreditBalancePositive?: boolean;
  description?: string;
  updateAtDate?: string;
  projectName?: string;
  spendingDemandType?: string;
  boxAssociationId?: string;
  boxId?: string;
  remak?: string;
  filesList?: FileItem[] | null;
  managerWaitingValidation?: User[];
  spendingDemandLastTeamFrom?: string;
  spendingDemandComptableTeam?: string;
  spendingDemandReadableId?: string;
}
export default function GeneralInfoView({
  userLastname,
  userName,
  statut,
  colorStatus,
  paymentDate,
  description,
  amount,
  totalSpent,
  remainingAmount,
  totalCredit,
  totalSubCredit,
  totalPayedCollab,
  totalAcompte,
  totalCreditAvailable,
  subCreditBalance,
  isTotalSpentExceeded,
  isRemainingAmountPositive,
  isSubCreditBalancePositive,
  projectName,
  spendingDemandType,
  boxAssociationId,
  boxId,
  updateAtDate,
  remak,
  filesList,
  managerWaitingValidation,
  spendingDemandLastTeamFrom,
  spendingDemandComptableTeam,
  spendingDemandReadableId,
}: GeneralInfoViewProps) {
  const managerListWaitingValidationString =
    managerWaitingValidation
      ?.map((manager) => manager?.firstname + " " + manager?.lastname)
      .join(", ") || "";

  const statusContent = [
    {
      title: "Statut",
      text: statut,
    },
  ];

  if (
    managerWaitingValidation &&
    managerWaitingValidation.length > 0 &&
    statut === "En attente de traitement"
  ) {
    statusContent.push({
      title: "En attente de la validation de",
      text: managerListWaitingValidationString,
    });
  }

  return (
    <div className={styles["general-info"]}>
      <div className={[styles["row"]].join(" ")}>
        <div className={[styles["column"], styles["column--left"]].join(" ")}>
          <div className={[styles["item"]].join(" ")}>
            
            <TextBox
            
              content={[
                {
                  title: "Montant Previsionel TTC",
                  text: amount,
                },
                ...(totalSpent ? [{
                  ...(isTotalSpentExceeded ? {
                    ItemRender: () => (
                      <div style={{ marginTop: '-5px' }}>
                        <h2 style={{ 
                          color: '#CC0000', 
                          margin: 0, 
                          marginRight: '10px', 
                          fontWeight: 100, 
                          fontSize: '0.8rem',
                          fontFamily: 'inherit'
                        }}>
                          Total dépensé
                        </h2>
                        <p style={{ 
                          color: '#CC0000', 
                          margin: 0, 
                          marginTop: '5px', 
                          fontWeight: 800, 
                          fontSize: '1rem',
                          fontFamily: 'inherit'
                        }}>
                          {totalSpent}
                        </p>
                      </div>
                    )
                  } : {
                    title: "Total dépensé",
                    text: totalSpent,
                  }),
                }] : []),
                ...(remainingAmount ? [{
                  ...(isRemainingAmountPositive ? {
                    ItemRender: () => (
                      <div style={{ marginTop: '-5px' }}>
                        <h2 style={{ 
                          color: '#006600', 
                          margin: 0, 
                          marginRight: '10px', 
                          fontWeight: 100, 
                          fontSize: '0.8rem',
                          fontFamily: 'inherit'
                        }}>
                          Montant restant
                        </h2>
                        <p style={{ 
                          color: '#006600', 
                          margin: 0, 
                          marginTop: '5px', 
                          fontWeight: 800, 
                          fontSize: '1rem',
                          fontFamily: 'inherit'
                        }}>
                          {remainingAmount}
                        </p>
                      </div>
                    )
                  } : {
                    title: "Montant restant",
                    text: remainingAmount,
                  }),
                }] : []),
              ]}
            />
          </div>
          {(totalCredit || totalCreditAvailable) && (
            <div className={[styles["item"]].join(" ")}>
              <TextBox
                content={[
                  ...(totalCredit ? [{
                    ItemRender: () => (
                      <div style={{ marginTop: '-5px' }}>
                        <h2 style={{ 
                          color: '#1976D2', 
                          margin: 0, 
                          marginRight: '10px', 
                          fontWeight: 100, 
                          fontSize: '0.8rem',
                          fontFamily: 'inherit'
                        }}>
                          Total crédit
                        </h2>
                        <p style={{ 
                          color: '#1976D2', 
                          margin: 0, 
                          marginTop: '5px', 
                          fontWeight: 800, 
                          fontSize: '1rem',
                          fontFamily: 'inherit'
                        }}>
                          {totalCredit}
                        </p>
                      </div>
                    )
                  }] : []),
                  ...(totalCreditAvailable ? [{
                    ItemRender: () => (
                      <div style={{ marginTop: '-5px' }}>
                        <h2 style={{ 
                          color: '#1976D2', 
                          margin: 0, 
                          marginRight: '10px', 
                          fontWeight: 100, 
                          fontSize: '0.8rem',
                          fontFamily: 'inherit'
                        }}>
                          Crédit restant
                        </h2>
                        <p style={{ 
                          color: '#1976D2', 
                          margin: 0, 
                          marginTop: '5px', 
                          fontWeight: 800, 
                          fontSize: '1rem',
                          fontFamily: 'inherit'
                        }}>
                          {totalCreditAvailable}
                        </p>
                      </div>
                    )
                  }] : []),
                ]}
              />
            </div>
          )}
          {totalSubCredit && (
            <div className={[styles["item"]].join(" ")}>
              <TextBox
                content={[
                  {
                    ItemRender: () => (
                      <div style={{ marginTop: '-5px' }}>
                        <h2 style={{
                          color: '#1976D2',
                          margin: 0,
                          marginRight: '10px',
                          fontWeight: 100,
                          fontSize: '0.8rem',
                          fontFamily: 'inherit'
                        }}>
                          Total crédité
                        </h2>
                        <p style={{
                          color: '#1976D2',
                          margin: 0,
                          marginTop: '5px',
                          fontWeight: 800,
                          fontSize: '1rem',
                          fontFamily: 'inherit'
                        }}>
                          {totalSubCredit}
                        </p>
                      </div>
                    )
                  },
                  ...(totalSpent ? [{
                    ItemRender: () => (
                      <div style={{ marginTop: '-5px' }}>
                        <h2 style={{
                          color: '#8B4513',
                          margin: 0,
                          marginRight: '10px',
                          fontWeight: 100,
                          fontSize: '0.8rem',
                          fontFamily: 'inherit'
                        }}>
                          Montant dépensé
                        </h2>
                        <p style={{
                          color: '#8B4513',
                          margin: 0,
                          marginTop: '5px',
                          fontWeight: 800,
                          fontSize: '1rem',
                          fontFamily: 'inherit'
                        }}>
                          {totalSpent}
                        </p>
                      </div>
                    )
                  }] : []),
                  ...(subCreditBalance ? [{
                    ...(isSubCreditBalancePositive ? {
                      ItemRender: () => (
                        <div style={{ marginTop: '-5px' }}>
                          <h2 style={{
                            color: '#006600',
                            margin: 0,
                            marginRight: '10px',
                            fontWeight: 100,
                            fontSize: '0.8rem',
                            fontFamily: 'inherit'
                          }}>
                            Balance
                          </h2>
                          <p style={{
                            color: '#006600',
                            margin: 0,
                            marginTop: '5px',
                            fontWeight: 800,
                            fontSize: '1rem',
                            fontFamily: 'inherit'
                          }}>
                            {subCreditBalance}
                          </p>
                        </div>
                      )
                    } : {
                      ItemRender: () => (
                        <div style={{ marginTop: '-5px' }}>
                          <h2 style={{
                            color: '#CC0000',
                            margin: 0,
                            marginRight: '10px',
                            fontWeight: 100,
                            fontSize: '0.8rem',
                            fontFamily: 'inherit'
                          }}>
                            Balance
                          </h2>
                          <p style={{
                            color: '#CC0000',
                            margin: 0,
                            marginTop: '5px',
                            fontWeight: 800,
                            fontSize: '1rem',
                            fontFamily: 'inherit'
                          }}>
                            {subCreditBalance}
                          </p>
                        </div>
                      )
                    }),
                  }] : []),
                ]}
              />
            </div>
          )}
          {(totalPayedCollab || totalAcompte) && (
            <div className={[styles["item"]].join(" ")}>
              <TextBox
                content={[
                  ...(totalPayedCollab ? [{
                    ItemRender: () => (
                      <div style={{ marginTop: '-5px' }}>
                        <h2 style={{
                          color: '#E65100',
                          margin: 0,
                          marginRight: '10px',
                          fontWeight: 100,
                          fontSize: '0.8rem',
                          fontFamily: 'inherit'
                        }}>
                          Payé par collaborateur
                        </h2>
                        <p style={{
                          color: '#E65100',
                          margin: 0,
                          marginTop: '5px',
                          fontWeight: 800,
                          fontSize: '1rem',
                          fontFamily: 'inherit'
                        }}>
                          {totalPayedCollab}
                        </p>
                      </div>
                    )
                  }] : []),
                  ...(totalAcompte ? [{
                    ItemRender: () => (
                      <div style={{ marginTop: '-5px' }}>
                        <h2 style={{
                          color: '#7B1FA2',
                          margin: 0,
                          marginRight: '10px',
                          fontWeight: 100,
                          fontSize: '0.8rem',
                          fontFamily: 'inherit'
                        }}>
                          Acompte
                        </h2>
                        <p style={{
                          color: '#7B1FA2',
                          margin: 0,
                          marginTop: '5px',
                          fontWeight: 800,
                          fontSize: '1rem',
                          fontFamily: 'inherit'
                        }}>
                          {totalAcompte}
                        </p>
                      </div>
                    )
                  }] : []),
                ]}
              />
            </div>
          )}
           <div className={[styles["item"]].join(" ")}>
            <TextBox
              content={[
                {
                  title: "Date de paiement",
                  text: paymentDate,
                },
                {
                  title: "Date de modification",
                  text: updateAtDate,
                },
              ]}
            />
          </div>
          <div className={[styles["item"]].join(" ")}>
            <TextBox
              content={[
                {
                  title: "Description",
                  text: description,
                },
              ]}
            />
          </div>
          {spendingDemandReadableId && (
            <div className={[styles["item"]].join(" ")}>
              <TextBox
                content={[
                  {
                    title: "Identifiant de la demande",
                    text: spendingDemandReadableId,
                  },
                ]}
              />
            </div>
          )}
          <div className={[styles["item"]].join(" ")}>
            <TextBox
              content={[
                {
                  title: "Employé(e)",
                  text: userName + " " + userLastname,
                },
              ]}
            />
          </div>
          {projectName && projectName !== "" && (
            <div className={[styles["item"]].join(" ")}>
              <TextBox
      
                content={[
                  {
                    title: "Projet",
                    text: projectName,
                  },
                ]}
              />
            </div>
          )}
          {spendingDemandType && (
            <div className={[styles["item"]].join(" ")}>
              <TextBox
                content={[
                  {
                    title: "Type de dépense",
                    text: spendingDemandType === 'PROJECT' ? 'Projet' : 
                          spendingDemandType === 'BOX' ? 'Box' : 
                          spendingDemandType === 'CURRENT' ? 'Dépense courante' : spendingDemandType,
                  },
                ]}
              />
            </div>
          )}
          {spendingDemandType === 'BOX' && (boxAssociationId || boxId) && (
            <div className={[styles["item"]].join(" ")}>
              <TextBox
                content={[
                  ...(boxAssociationId ? [{
                    title: "Box Association ID",
                    text: boxAssociationId,
                  }] : []),
                  ...(boxId ? [{
                    title: "Box ID",
                    text: boxId,
                  }] : []),
                ]}
              />
            </div>
          )}
          {spendingDemandLastTeamFrom && (
            <div className={[styles["item"]].join(" ")}>
              <TextBox
                content={[
                  {
                    title: "Équipe d'origine ProBy",
                    ItemRender: () => <TeamInfo id={spendingDemandLastTeamFrom} attribute="team_name" />,
                  },
                ]}
              />
            </div>
          )}
          {spendingDemandComptableTeam && (
            <div className={[styles["item"]].join(" ")}>
              <TextBox
                content={[
                  {
                    title: "Équipe comptable",
                    ItemRender: () => <TeamInfo id={spendingDemandComptableTeam} attribute="team_name" />,
                  },
                ]}
              />
            </div>
          )}
        </div>
        <div className={[styles["column"], styles["column--right"]].join(" ")}>
          <div className={styles["sticky-wrapper"]}>
            <div className={[styles["item"]].join(" ")}>
              <TextBox           colorStyle={colorStatus} content={statusContent} />
            </div>
            <div className={[styles["item"]].join(" ")}>
              <TextBox
                content={[
                  {
                    title: "Historique de traitement",
                    ItemRender: () => <HistoricStatusPresenter />,
                  },
                ]}
              />
            </div>
          </div>
          
        </div>
      </div>
   

      <div className={[styles["row"], styles["row--description"]].join(" ")}>
        <div
          className={[styles["column"], styles["column--letf"]].join(" ")}
        ></div>
      </div>
      <div className={[styles["row"], styles["row--employee"]].join(" ")}>
        <div
          className={[styles["column"], styles["column--letf"]].join(" ")}
        ></div>
      </div>



      {filesList && filesList.length > 0 && (
        <div className={[styles["row"], styles["row--files"]].join(" ")}>
          <div className={[styles["column"], styles["column--letf"]].join(" ")}>
            <FilesList filesList={filesList} label="Justificatifs" />
          </div>
        </div>
      )}
    </div>
  );
}
